import { FilletFeatureDefinitionModel } from '../../../feature/definition/fillet/FilletFeatureDefinition';
import { FilletFeaturePrototype } from '../../../feature/prototype/fillet/FilletFeaturePrototype';
import { FilletPreviewObject } from '../fillet/FilletPreviewObject';
import { FilletResultObject } from '../fillet/FilletResultObject';
import { FeatureMeshObjectFactory, type FeatureMeshObjectBuildInput } from './FeatureMeshObjectFactory';

/**
 * 圆角特征 mesh 对象工厂。
 */
export class FilletMeshObjectFactory extends FeatureMeshObjectFactory {
    /**
     * @inheritdoc
     */
    public create(input: FeatureMeshObjectBuildInput) {
        if (input.isPreview) {
            if (
                input.context?.prototype instanceof FilletFeaturePrototype
                && input.context.draftDefinition instanceof FilletFeatureDefinitionModel
            ) {
                return new FilletPreviewObject({
                    prototype: input.context.prototype,
                    draftDefinition: input.context.draftDefinition,
                    meshData: input.meshData,
                    geometry: input.geometry,
                    material: input.material,
                });
            }
            return null;
        }

        if (input.context?.prototype instanceof FilletFeaturePrototype) {
            return new FilletResultObject({
                prototype: input.context.prototype,
                meshData: input.meshData,
                geometry: input.geometry,
                material: input.material,
            });
        }

        return null;
    }
}
